<template>
  <div class="container-fluid">
    <div class="align-right-div">
      <button class="btn btn-secondary reset-filter-button" @click="resetFilters(); viewTriggers++;">
        <i class="fa fa-retweet"/>
        <template>
          {{ $t('shopfloor.teamlead.orderHandling.resetFilter') }}
        </template>
      </button>
      <button class="btn btn-secondary" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"/>
        <template v-if="!filterOpen">
          {{ $t('shopfloor.teamlead.orderHandling.openFilter') }}
        </template>
        <template v-else>
          {{ $t('shopfloor.teamlead.orderHandling.closeFilter') }}
        </template>
      </button>
    </div>
    <div class="row dataTable-filters orderlines-dt-filter" :class="filterOpenClass">
      <!-- TRUCK NUMBER -->
      <div class="table-filter">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{ $t('shopfloor.teamlead.orderHandling.truck') }} ({{
                customFilters[0].options.values.length
              }})</span>
          </button>
          <div class="dropdown-menu">
            <input v-model="searchTruck" class="form-control mb-3" type="text"
                   :placeholder="$t('shopfloor.teamlead.orderHandling.filter')">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox" v-for="(truckNumber, index) in searchByTruck"
                   :key="truckNumber+'-'+index">
                <input v-model="customFilters[0].options.values"
                       :value="truckNumber"
                       type="checkbox"
                       :id="'truckNumber-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'truckNumber-'+index">
                  <span>{{
                      (truckNumber === '' || truckNumber === undefined) ? $t('shopfloor.teamlead.orderHandling.noTruckNumber') : truckNumber
                    }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- CUSTOMER -->
      <div class="table-filter">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{ $t('shopfloor.teamlead.orderHandling.customer') }} ({{
                customFilters[1].options.values.length
              }})</span>
          </button>
          <div class="dropdown-menu">
            <input v-model="searchCustomer" class="form-control mb-3" type="text"
                   :placeholder="$t('shopfloor.teamlead.orderHandling.filter')">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox"
                   v-for="(customer, index) in searchByCustomerName"
                   :key="customer+'-'+index">
                <input v-model="customFilters[1].options.values"
                       :value="customer"
                       type="checkbox"
                       :id="'customer-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'customer-'+index">
                  <span>{{
                      (customer === '' || customer === undefined) ? $t('shopfloor.teamlead.orderHandling.noCustomerName') : customer
                    }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TRAILER -->
      <div class="table-filter">
        <div class="dropdown">
          <button class="btn btn-outline-filter dropdown-toggle" type="button">
            <span>{{ $t('shopfloor.teamlead.orderHandling.trailerNumber') }} ({{
                customFilters[2].options.values.length
              }})</span>
          </button>
          <div class="dropdown-menu">
            <input v-model="searchTrailerNumber" class="form-control mb-3" type="text"
                   :placeholder="$t('shopfloor.teamlead.orderHandling.filter')">
            <div class="option-wrapper">
              <div class="custom-control custom-checkbox"
                   v-for="(trailerNumber, index) in searchByTrailerNumber"
                   :key="trailerNumber+'-'+index">
                <input v-model="customFilters[2].options.values"
                       :value="trailerNumber"
                       type="checkbox"
                       :id="'trailerNumber-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'trailerNumber-'+index">
                  <span>{{
                      (trailerNumber === '' || trailerNumber === undefined) ? $t('shopfloor.teamlead.orderHandling.noTrailerNumber') : trailerNumber
                    }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- DATE -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.selectedDate') }}</label>
        <datepicker
            monday-first
            :language="nl"
            :format="dateDisplay"
            @selected="selectedDateChanged"
            :value="selectedDate"
            id="selectedDate" input-class="form-control "/>
      </div>

      <!-- State -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.states.title') }}</label>
        <div class="option-wrapper">
          <div class="custom-control custom-checkbox"
               v-for="(state, index) in uniqueStates"
               :key="state+'-'+index">
            <input v-model="customFilters[3].options.values"
                   :value="state"
                   type="checkbox"
                   :id="'state-'+index"
                   class="custom-control-input"
            >
            <label class="custom-control-label" :for="'state-'+index">
              <div class="state-filter">
                <span>{{ $t(`shopfloor.teamlead.orderHandling.states.${currentView}.${state}`) }}</span>
                <div class="circle" v-bind:class="'status-' + currentView  +'-' + state"></div>
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- State -->
      <div class="table-filter">
        <label>{{ $t('shopfloor.teamlead.orderHandling.view.title') }}</label>
        <div class="option-wrapper">
          <div class="custom-control custom-radio">
            <input v-model="currentView"
                   value="loading"
                   type="radio"
                   v-on:change="viewChangeTriggered"
                   name="view"
                   id="view-loading"
                   class="custom-control-input"
            >
            <label class="custom-control-label" for="view-loading">
              <span>{{ $t(`shopfloor.teamlead.orderHandling.view.loading`) }}</span>
            </label>
          </div>
          <div class="custom-control custom-radio">
            <input v-model="currentView"
                   value="unloading"
                   type="radio"
                   v-on:change="viewChangeTriggered"
                   name="view"
                   id="view-unloading"
                   class="custom-control-input"
            >
            <label class="custom-control-label" for="view-unloading">
              <span>{{ $t(`shopfloor.teamlead.orderHandling.view.unloading`) }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentView === 'unloading'" class="selection-buttons">
      <button :disabled="getAmountToSelectLeft() < 0 || !selectedRows.length || saving" class="btn btn-primary"
              :class="saving === 'manco' ? 'blink-button' : ''"
              @click="handleSelectedRows('manco')">
        {{
          $t(saving === 'manco' ? 'shopfloor.teamlead.orderHandling.actions.manco.busy' : 'shopfloor.teamlead.orderHandling.buttons.declareDefect')
        }}
      </button>
      <button :disabled="selectedDoneRows() || getAmountToSelectLeft() < 0 || !selectedRows.length || saving"
              class="btn btn-primary"
              :class="saving === 'unload' ? 'blink-button' : ''"
              @click="handleSelectedRows('unload')">
        {{ $t('shopfloor.teamlead.orderHandling.buttons.unload') }}

      </button>
    </div>
    <div class="table-responsive">
      <datatables
          :columns="getColumns()"
          ref="orderHandlingTable"
          :rows="getProductsWithCargoAndOrder"
          :tableClass="tableClass"
          :tableInitOptions="tableInitOptions"
          deleteClass="delete"
          :key="currentView + '-' + selectedDate.toJSON() + '-' + viewTriggers"
          :customFilters="customFilters"
          tableID="order-handling-dt"
          v-if="getProductsWithCargoAndOrder"
      />
    </div>
    <div class="invisibleClicker" id="emptyCheckbox" @click="selectRow($event)"></div>
    <th v-if="currentView === 'unloading'" class="invisibleClicker" id="emptyClicker" @click="selectAll($event)">
      <div class="custom-control custom-checkbox"><input type="checkbox" id="select-all-checkbox"
                                                         class="custom-control-input"><label
          class="custom-control-label" for="select-all-checkbox">&nbsp;</label></div>
    </th>
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import dataTables from '../../mixins/datatables';
import Datepicker from 'vuejs-datepicker';
import {nl} from 'vuejs-datepicker/dist/locale';


export default {
  name: 'teamlead-order-handling',
  components: {Datepicker},
  mixins: [dataTables],
  data() {
    return {
      bc: null,
      saving: null,
      masterCheckbox: undefined,
      selectedRows: [],
      viewTriggers: 0,
      maxSelectedWithoutFilter: 200,
      currentView: 'loading',
      nl: nl,
      defaultSelected: {
        truck: undefined,
        trailer: undefined,
        date: undefined
      },
      searchTruck: '',
      searchCustomer: '',
      searchTrailerNumber: '',
      selectedDate: new Date(),
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      tableClass: 'table-striped table-bordered     responsive nowrap',
      tableInitOptions: {
        stateSave: true,
        language: {
          "lengthMenu": "_MENU_ resultaten weergeven",
          "zeroRecords": "Geen resultaten gevonden",
          "infoEmpty": "Geen resultaten om weer te geven",
          "search": "Zoeken:",
          "emptyTable": "Geen resultaten aanwezig in de tabel",
          "infoThousands": ".",
          "loadingRecords": "Een moment geduld aub - bezig met laden...",
          "paginate": {
            "first": "Eerste",
            "last": "Laatste",
            "next": "Volgende",
            "previous": "Vorige"
          },
          "aria": {
            "sortAscending": ": activeer om kolom oplopend te sorteren",
            "sortDescending": ": activeer om kolom aflopend te sorteren"
          },
          "autoFill": {
            "fill": "Vul alle cellen met <i>%d</i>",
            "fillHorizontal": "Vul cellen horizontaal",
            "fillVertical": "Vul cellen verticaal"
          },
          "buttons": {
            "collection": "Collectie",
            "colvis": "Kolom zichtbaarheid",
            "colvisRestore": "Herstel zichtbaarheid",
            "copy": "Kopieer",
            "copySuccess": {
              "1": "1 regel naar klembord gekopieerd",
              "_": "%ds regels naar klembord gekopieerd"
            },
            "copyTitle": "Kopieer naar klembord",
            "csv": "CSV",
            "excel": "Excel",
            "pageLength": {
              "-1": "Toon alle regels",
              "_": "Toon %d regels"
            },
            "pdf": "PDF",
            "print": "Print"
          },
          "info": "_START_ tot _END_ van _TOTAL_ regels",
          "infoFiltered": " (gefilterd uit _MAX_ regels)",
          "processing": "Verwerken..."
        },
        drawCallback: this.afterDraw,
        select: true,
        pageLength: 25,
        order: [[this.currentView === 'loading' ? 2 : 3, 'desc']]
      },
      customFilters: []
    };
  },
  computed: {
    ...mapGetters('orderProducts', ['getProductsWithCargoAndOrderOutgoing']),
    ...mapGetters('incomingOrderProducts', ['getProductsWithCargoAndOrderIncoming', 'getProduct']),
    ...mapGetters('customers', ['getCustomers']),
    ...mapGetters('users', ['getMeBasic']),
    ...mapGetters('batchUnload', ['getBatchUnloads']),
    ...mapGetters('deviationFixerQueue', ['getDeviationFixerQueue']),
    ...mapGetters('incomingOrders', ['getOrders']),
    getProductsWithCargoAndOrder() {
      return this.currentView === 'loading' ? this.getProductsWithCargoAndOrderOutgoing : this.getProductsWithCargoAndOrderIncoming;
    },
    searchByTruck() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.truckNumber && `${product.truckNumber}`.toLowerCase().indexOf(`${this.searchTruck}`.toLowerCase()) >= 0;
      }), 'truckNumber')).sort(this.sortCaseInsensitive);
    },
    searchByCustomerName() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.customer && `${product.customer}`.toLowerCase().indexOf(`${this.searchCustomer}`.toLowerCase()) >= 0;
      }), 'customer')).sort(this.sortCaseInsensitive);
    },
    searchByTrailerNumber() {
      return _.uniq(_.map(this.getProductsWithCargoAndOrder.filter((product) => {
        return product.trailerNumber && `${product.trailerNumber}`.toLowerCase().indexOf(`${this.searchTrailerNumber}`.toLowerCase()) >= 0;
      }), 'trailerNumber')).sort(this.sortCaseInsensitive);
    },
    uniqueStates() {
      return ['idle', 'busy', 'done'];
    }
  },
  methods: {
    ...mapActions('incomingOrderProducts', [
      'updateAmountLocally'
    ]),
    create_UUID() {
      let dt = new Date().getTime();
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    handleSelectedRows(action) {
      const html = this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.message').replace('[AMOUNT]', `<b>${this.selectedRows.length}</b>`)
      this.$swal({
        customClass: 'm-swal-load-unload',
        width: '80%',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.title'),
        html,
        cancelButtonColor: '#d33',
        showConfirmButton: true,
        confirmButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.confirm'),
        cancelButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.actions.' + action + '.cancel')
      }).then(async result => {
        if (result.value) {
          if (action === 'manco') {
            this.saving = 'manco';
            const guids = [];
            let amountToUnloadTotal = 1;
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
                let amountToUnload = incomingProduct.amount - (incomingProduct.amountUnloaded ? incomingProduct.amountUnloaded : 0);
                amountToUnloadTotal += amountToUnload;
                const date = new Date();
                const deviationIds = [];
                for (let i = 0; i < amountToUnload; i++) {
                  let deviation = {
                    amount: 1,
                    companyId: this.getMeBasic.companyId,
                    location: 'unloading',
                    created_at: date,
                    locationAdditional: incomingProduct.productNumber,
                    userId: this.getMeBasic.userId,
                    userName: this.getMeBasic.userName,
                    // recordId: incomingProduct.id,
                    orderId: incomingProduct.incomingOrderId,
                    remark: 'Gemeld via orderafhandeling',
                    type: 'shortage'
                  }
                  const devRes = await this.$FB.collection('deviations').add(deviation);
                  deviationIds.push(devRes.id);
                }
                if (deviationIds.length) {
                  let guid = this.create_UUID();
                  guids.push(guid);
                  await this.$FB.collection('deviation-fixer-queue').add({
                    amount: amountToUnload,
                    deviationIds: deviationIds,
                    companyId: this.getMeBasic.companyId,
                    location: 'unloading',
                    guid,
                    packingListNumber: incomingProduct.packingListNumber,
                    uniqueIncomingProductIndex: incomingProduct.uniqueIndex,
                    created_at: date,
                    locationAdditional: incomingProduct.productNumber,
                    userId: this.getMeBasic.userId,
                    userName: this.getMeBasic.userName,
                    recordId: incomingProduct.id,
                    orderId: incomingProduct.incomingOrderId,
                    remark: 'Gemeld via orderafhandeling',
                    type: 'shortage'
                  });
                }
              }
            }
            this.deselectAllRows();

            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (this.getDeviationFixerQueue.indexOf(guids[i]) > -1) {
                  allDone = false;
                }
              }
              if (allDone) {
                clearInterval(doneInterval);
                setTimeout(() => {
                  this.saving = null;
                  this.$swal({
                    position: 'bottom-end',
                    icon: 'success',
                    title: this.$root.$t('shopfloor.teamlead.orderHandling.actions.manco.done'),
                    showConfirmButton: false,
                    timer: 2000
                  });
                }, amountToUnloadTotal * 1000);
              }
            }, 500);
          } else if (action === 'unload') {
            this.saving = 'unload';
            let promises = []
            const guids = [];
            for (let i = 0; i < this.selectedRows.length; i++) {
              const incomingProduct = this.getProduct(this.selectedRows[i]);
              // if (incomingProduct.amountUnloaded == undefined || incomingProduct.amountUnloaded < incomingProduct.amount) {
              let guid = this.create_UUID();
              guids.push(guid);
              promises.push(this.$FB.collection('batch-unload').add({
                companyId: this.getMeBasic.companyId,
                endTime: new Date(),
                locationId: this.getMeBasic.companyId === 7 ? 1042 : 123456789,
                guid,
                barcodeUnreadable: true,
                startTime: new Date(),
                userId: this.getMeBasic.userId,
                userName: this.getMeBasic.userName,
                dateFrom: moment(this.selectedDate).startOf('day').toDate(),
                dateTo: moment(this.selectedDate).endOf('day').toDate(),
                type: {
                  value: incomingProduct.id,
                  key: 'id',
                }
              }))
              // await this.$FB.collection('batch-unload').add({
              //   companyId: this.getMeBasic.companyId,
              //   endTime: new Date(),
              //   locationId: 1042,
              //   guid,
              //   barcodeUnreadable: true,
              //   startTime: new Date(),
              //   userId: this.getMeBasic.userId,
              //   userName: this.getMeBasic.userName,
              //   dateFrom: moment(this.selectedDate).startOf('day').toDate(),
              //   dateTo: moment(this.selectedDate).endOf('day').toDate(),
              //   type: {
              //     value: incomingProduct.id,
              //     key: 'id',
              //   }
              // });
              // }
            }
            Promise.all(promises)
            this.deselectAllRows();
            this.$swal({
              toast: true,
              position: 'bottom-end',
              icon: 'success',
              html: this.$root.$t('shopfloor.teamlead.orderHandling.actions.unload.done'),
              showConfirmButton: false,

            });
            const doneInterval = setInterval(() => {
              let allDone = true;
              for (let i = 0; i < guids.length; i++) {
                if (this.getBatchUnloads.indexOf(guids[i]) > -1) {
                  allDone = false;
                }
              }
              if (allDone) {
                clearInterval(doneInterval);

                this.saving = null;


              }
            }, 500);
          }
        }
      });
    },
    selectedDoneRows() {
      const selectedProducts = _.filter(this.getProductsWithCargoAndOrder, (product) => {
        return _.indexOf(this.selectedRows, product.id) > -1;
      });
      // const selectedProducts = this.getProductsWithCargoAndOrder.filter(product => {
      //   return this.selectedRows.indexOf(product.id) > -1;
      // });
      return _.findIndex(selectedProducts, { 'state': 'done' }) > -1;
      // return selectedProducts.findIndex(selectedProduct => {
      //   return selectedProduct.state === 'done';
      // }) > -1;
    },
    getAmountToSelectLeft() {
      const allFiltersExceptDate = this.customFilters.filter(customFilter => customFilter.filter !== "dateRangeFilter");
      let allEmptyFilters = allFiltersExceptDate.filter(customFilter => customFilter.options.values.length === 0);

      // If state filter has busy and idle selected: we consider as 'no filter'
      const stateFilter = this.customFilters.find(customFilter => customFilter.keyToFilter === 'state');
      if (stateFilter.options.values.indexOf('idle') > -1 && stateFilter.options.values.indexOf('busy') > -1) {
        allEmptyFilters.push(stateFilter);
      }

      if (allFiltersExceptDate.length === allEmptyFilters.length) {
        return this.maxSelectedWithoutFilter - this.selectedRows.length;
      } else {
        return undefined;
      }
    },
    showSelectionLimitPopUp() {
      return this.$swal({
        title: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.title'),
        text: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.message'),
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: this.$root.$t('shopfloor.teamlead.orderHandling.maxSelected.closeButton'),
        reverseButtons: true
      })
    },
    selectRow($event) {
      const clickedId = this.currentView === 'loading' ? parseInt($('#emptyCheckbox').attr('clickedId')) : $('#emptyCheckbox').attr('clickedId');
      const indexOfSelectedId = this.selectedRows.indexOf(clickedId);
      const leftToSelect = this.getAmountToSelectLeft();
      if (leftToSelect === undefined || leftToSelect >= 1) {
        if (indexOfSelectedId > -1) {
          this.selectedRows.splice(indexOfSelectedId, 1);
        } else {
          this.selectedRows.push(clickedId);
        }
      } else {
        this.showSelectionLimitPopUp();
        $event.srcElement.checked = false;
      }
    },
    selectAll($event) {
      const allIds = $event.srcElement.checked ? this.$refs.orderHandlingTable.TABLE.rows({search: 'applied'}).data().map(row => row.id) : [];
      const leftToSelect = this.getAmountToSelectLeft();
      if (leftToSelect === undefined || leftToSelect > allIds.length) {
        this.selectedRows = [];
        for (let i = 0; i < allIds.length; i++) {
          this.selectedRows.push(allIds[i])
        }
      } else {
        this.showSelectionLimitPopUp();
        $event.srcElement.checked = false;
      }
    },
    deselectAllRows() {
      this.selectedRows = [];
    },
    afterDraw() {
      if (this.currentView === 'unloading') {
        const columns = $("th:contains(Auto)").parent().children();
        const checkboxElement = $('#emptyClicker').get(0);
        if (checkboxElement) {
          this.masterCheckbox = checkboxElement;
        }
        if (columns[0].innerHTML === 'Auto') {
          // Append col
          $("th:contains(Auto)").parent().children().append(this.masterCheckbox);
        } else {
          // Replace col
          $("th:contains(Auto)").parent().children().first().replaceWith(this.masterCheckbox)
        }
      }
    },
    async viewChangeTriggered(event) {
      this.$store.commit('setLoading', true)
      await this.closeView();
      localStorage.setItem('orderhandling-view', this.currentView);
      this.$globalEventBus.$emit('orderhandling-view-changed', this.currentView);

      if (this.currentView === 'loading') {
        this.$router.push({name: 'teamlead-order-handling-loading'}, () => {
          this.createView();
        });
      } else {
        this.$router.push({name: 'teamlead-order-handling-unloading'}, () => {
          this.createView();
        })
      }
    },
    selectedDateChanged(date) {
      this.selectedDate = date;
      this.resetFilters();
      return this.openOrderProductsDBChannel(moment(this.selectedDate));
    },
    dateDisplay(date) {
      return moment(date).format('DD/MM/YY');
    },
    sortCaseInsensitive(a, b) {
      return `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase());
    },
    async openOrderProductsDBChannel(date) {
      let skipCloseDB = false;
      if (!date) {
        if (this.defaultSelected.date) {
          date = moment(this.defaultSelected.date.toDate());
          this.selectedDate = this.defaultSelected.date.toDate();
          this.defaultSelected.date = undefined;
        } else {
          date = moment();
        }
        skipCloseDB = true;
      }
      if (!skipCloseDB) {
        if (this.currentView === 'loading') {
          await this.$store.dispatch('orderProducts/closeDBChannel', {clearModule: true});
          await this.$store.dispatch('orders/closeDBChannel', {clearModule: true});
        }
        if (this.currentView === 'unloading') {
          await this.$store.dispatch('incomingOrderProducts/closeDBChannel', {clearModule: true})
          await this.$store.dispatch('incomingOrders/closeDBChannel', {clearModule: true});
        }
      }

      if (this.currentView === 'loading') {
        let where = [['companyId', '==', this.getMeBasic.companyId], ['estimatedTimeOfDeparture', '>=', date.startOf('day').toDate()], ['estimatedTimeOfDeparture', '<=', date.endOf('day').toDate()]]
        await this.$store.dispatch('orders/openDBChannel', {where})
        await this.$store.dispatch('orderProducts/openDBChannel', {where});
      }
      if (this.currentView === 'unloading') {
        let where = [['companyId', '==', this.getMeBasic.companyId], ['estimatedTimeOfArrival', '>=', date.startOf('day').toDate()], ['estimatedTimeOfArrival', '<=', date.endOf('day').toDate()]]
        await this.$store.dispatch('incomingOrders/openDBChannel', {where})
        await this.$store.dispatch('incomingOrderProducts/openDBChannel', {where});
      }
      this.$store.commit('setLoading', false)

      this.viewTriggers++;
    },
    getColumns() {
      let self = this;
      return (this.currentView === 'loading' ? [] : [
        {
          data: null,
          name: '',
          searchable: false,
          sortable: false,
          render(data) {
            const clickfunction = `$('#emptyCheckbox').attr('clickedId', '${data.id}'); $('#emptyCheckbox').click();`
            if (self.selectedRows.includes(data.id)) {
              return '<div class="custom-control custom-checkbox"><input onclick="' + clickfunction + '" value="' + data.id + '" type="checkbox" checked id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
            } else {
              return '<div class="custom-control custom-checkbox"><input onclick="' + clickfunction + '" value="' + data.id + '" type="checkbox" id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
            }
          }
        }
      ]).concat([
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.truck'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.truckNumber ? data.truckNumber : '';
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.trailer'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.trailerNumber ? data.trailerNumber : '';
          }
        },
        {
          data: this.currentView === 'loading' ? 'estimatedTimeOfDeparture' : 'estimatedTimeOfArrival',
          name: this.$t('shopfloor.teamlead.orderHandling.date.' + this.currentView),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return moment(data.toDate()).format('DD/MM  HH:mm');
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.productNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            const clickAction = `window.VueGlobalEventBus.$emit('barcodeClicked', '${data.productNumber}')`;
            return `<a style="cursor: pointer;" onClick="${clickAction}">${data.productNumber}</a>`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.customer'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return `<div style="white-space: normal;">${data.customer}</div>`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.address'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            const person = 'receiver';
            const zipCode = data[person].zipcode ? data[person].zipcode : '';
            const city = data[person].city ? data[person].city : '';
            const address = data[person].address ? data[person].address : '';
            return `${zipCode}, ${city}<br/>${address}`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.packingListNumber'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            if (data.deviationPresent) {
              return `<div class='deviationPresentContainer'>
                        <div class="packingListNumber">${data.packingListNumber}</div>
                        <div class="deviation-present" onclick="window.VueGlobalEventBus.$emit('OpenDeviations', '${data.id}')">
                          <i class="test far fa-exclamation-circle"></i>
                        </div>
                      </div>`;
            } else {
              return data.packingListNumber;
            }
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.state'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data, type) {
            if (type === 'sort') {
              return data.state
            }
            return `<div class="circle status-${self.currentView}-${data.state}"></div>`;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.type'),
          searchable: true,
          className: 'alignCenter',
          sortable: true,
          visible: true,
          render(data) {
            return data.productName;
          }
        },
        {
          data: null,
          name: this.$t('shopfloor.teamlead.orderHandling.progress'),
          searchable: true,
          className: 'alignCenter',
          sortable: false,
          visible: true,
          render(data) {
            let amountDone = 0;
            if (self.currentView === 'loading' && data.amountLoaded) {
              amountDone = data.amountLoaded;
            }
            if (self.currentView === 'unloading' && data.amountUnloaded) {
              amountDone = data.amountUnloaded;
            }
            return `${amountDone} / ${data.amount} ${data.retour ? '(r)' : ' '}`;
          }
        }
      ]).concat(this.currentView === 'loading'
          ? [{
            data: null,
            name: this.$t('shopfloor.teamlead.loading.outgoingCargo.openUser'),
            searchable: true,
            className: 'break-usernames',
            sortable: false,
            visible: true,
            render(data) {
              if (data.loadedUsers) {
                return _.map(data.loadedUsers, 'userName').join(', ');
              } else {
                return '';
              }
            }
          }]
          : [
            {
              data: null,
              name: this.$t('shopfloor.teamlead.loading.outgoingCargo.openUser'),
              searchable: true,
              className: 'break-usernames',
              sortable: false,
              visible: true,
              render(data) {
                if (data.unloadedUsers) {
                  return _.map(data.unloadedUsers, 'userName').join(', ');
                } else {
                  return '';
                }
              }
            }
          ]);
    },
    async closeView(to) {
      const store = this.currentView === 'loading' ? ['orders', 'orderProducts'] : (!to || (to.name !== 'teamlead-cargos-unloading' && to.name !== 'unloaded') ? ['incomingOrderProducts'] : []).concat(['incomingOrders', 'deviationFixerQueue', 'batchUnload']);
      return this.$store.dispatch('resetStoreModules', store).catch(console.error);
    },
    resetFilters() {
      const defaultTruckFilter = [];
      const defaultTrailerFilter = [];
      if (this.defaultSelected.trailer) {
        defaultTrailerFilter.push(this.defaultSelected.trailer);
        this.defaultSelected.trailer = undefined;
      }
      if (this.defaultSelected.truck) {
        defaultTruckFilter.push(this.defaultSelected.truck);
        this.defaultSelected.truck = undefined;
      }
      this.customFilters = [
        {
          filter: 'arrayContains',
          keyToFilter: 'truckNumber',
          options: {
            values: defaultTruckFilter
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'customer',
          options: {
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'trailerNumber',
          options: {
            values: defaultTrailerFilter
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'state',
          options: {
            values: ['done', 'busy', 'idle']
          }
        }
      ];
      this.searchTrailerNumber = '';
      this.searchTruck = '';
      this.searchCustomer = '';
      this.selectedRows = [];
    },
    async createView() {
      this.selectedRows = [];
      this.selectedDate = new Date();
      this.resetFilters();
      // this.currentView = this.$route.meta['view'];
      this.currentView = localStorage.getItem('orderhandling-view')

      const store = this.currentView === 'loading' ? [] : ['deviationFixerQueue', 'batchUnload'];
      let where = [['companyId', '==', this.getMeBasic.companyId]]
      for (let i = 0; i < store.length; i++) {
        await this.$store.dispatch(store[i] + '/openDBChannel', {where})
      }
      return this.openOrderProductsDBChannel();
    }
  },
  watch: {
    filterOpen: function (filter) {
      if (filter) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.name !== 'teamlead-order-handling-loading' && to.name !== 'teamlead-order-handling-unloading') {
      window.VueGlobalEventBus.$off('barcodeClicked');
    }
    await this.closeView(to);
    next();
  },
  created() {
    window.VueGlobalEventBus.$on('barcodeClicked', (data) => {
      return this.$router.push({name: 'TrackAndTrace', params: { productNumber: data }});
    });
    window.VueGlobalEventBus.$on('OpenDeviations', (data) => {
      if (this.currentView === 'loading') {
        this.$router.push({
          name: 'teamlead-deviations-loading',
          params: {recordId: data}
        });
      } else {
        this.$router.push({
          name: 'teamlead-deviations-unloading',
          params: {recordId: data}
        });
      }
    });
    this.$store.commit('setLoading', true)
    if (!localStorage.getItem('orderhandling-view')) {
      if (this.$route.params && this.$route.params.cargo && this.$route.params.cargo.cargoType === 'incoming') {
        localStorage.setItem('orderhandling-view', 'unloading')
        this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
      } else {
        localStorage.setItem('orderhandling-view', 'loading');
        this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
      }
    } else {
      if (this.$route.params && this.$route.params.cargo) {
        if (this.$route.params.cargo.cargoType === 'incoming') {
          localStorage.setItem('orderhandling-view', 'unloading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'unloading');
        } else {
          localStorage.setItem('orderhandling-view', 'loading');
          this.$globalEventBus.$emit('orderhandling-view-changed', 'loading');
        }
      }
    }

    if (this.$route.params && this.$route.params.cargo) {
      this.defaultSelected.trailer = this.$route.params.cargo.trailerNumber;
      this.defaultSelected.truck = this.$route.params.cargo.truckNumber;
      this.defaultSelected.date = this.$route.params.cargo.estimatedTimeOfArrival ? this.$route.params.cargo.estimatedTimeOfArrival : this.$route.params.cargo.estimatedTimeOfDeparture;
    }
    this.createView();
  }
};
</script>


<style lang="scss">
.status-loading-idle {
  background-color: #ffa0a0;
}

.status-loading-busy {
  background-color: #ffaf46;
}

.status-loading-done {
  background-color: #00b954;
}


.status-unloading-idle {
  background-color: white;
  border: 1px solid black !important;
}

.status-unloading-busy {
  background-color: gray;
}

.status-unloading-done {
  background-color: #00c9ff;
}

.circle {
  width: 2rem;
  height: 2rem;
  border: 1px solid white;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
}

.align-right-div {
  text-align: right;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.state-filter {
  display: grid;
  grid-template-columns: 13rem 2rem;;
  grid-template-rows: auto;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
}

.selection-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 0px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.dataTable-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  margin: 1rem;
}

.m-hide-lg {
  visibility: hidden;
  height: 0px;
}

.container-fluid {
  margin-bottom: 15px;
}

.reset-filter-button {
  margin-right: 1rem;
}

.blink-button {
  -webkit-animation: blink 5s infinite; /* Safari 4+ */
  -moz-animation: blink 5s infinite; /* Fx 5+ */
  -o-animation: blink 5s infinite; /* Opera 12+ */
  animation: blink 5s infinite; /* IE 10+, Fx 29+ */
}

.deviation-present {
  color: red;
  font-weight: bold;
  font-size: 1.8rem;
  cursor: pointer;
}

.packingListNumber {
  align-self: center;
}

.deviationPresentContainer {
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-template-rows: 1fr 0px;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}


</style>
<style>
.break-usernames {
  word-break: normal;
  white-space: normal !important;
}
</style>